import { makeStyles } from '@material-ui/core/styles';
import { PANEL_WIDTH } from './panel.styles';

// The classic host needs 1200px plus its fixed back controls and the 440px panel.
export const STAFF_DOCK_MIN_WIDTH = 1800;
export default makeStyles((theme) => ({
  host: { display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0, minWidth: 0 },
  docked: { marginRight: PANEL_WIDTH, transform: 'translateZ(0)' },
  launcherWrapper: { display: 'flex', alignSelf: 'stretch' },
  // Mirrors the header tabs (core/components/header-tab + theme MuiTab override).
  launcher: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 5),
    font: 'inherit',
    fontSize: 24,
    fontWeight: 300,
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
    color: theme.colors.text_primary,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.colorPalette.orange_50_op_08 },
    '&:focus-visible': { outline: `2px solid ${theme.colorPalette.orange_50}`, outlineOffset: -2 }
  },
  launcherOpen: { fontWeight: 600 },
  launcherIcon: {
    width: 28,
    height: 28,
    '& path': { stroke: theme.colorPalette.orange_50, strokeWidth: 1.5 }
  },
  backdrop: { position: 'fixed', inset: 0, zIndex: 1240, background: theme.colorPalette.green_90_op_80 }
}));
